import { Box } from '@mui/system';
import { ReactNode } from 'react';

interface PaddedContainerProps {
  children: ReactNode;
  className?: string;
  bgColor?: string;
  bgColorMobile?: string;
}

const PaddedContainer = ({
  children,
  className = '',
  bgColor,
  bgColorMobile,
}: PaddedContainerProps) => {
  return (
    <Box
      className={`mx-auto ${className}`}
      sx={{
        backgroundColor: {
          xs: bgColorMobile || bgColor, // mobile view
          md: bgColor,                  // md and above
        },
      }}
    >
      {children}
    </Box>
  );
};

export default PaddedContainer;
